import { Button, Loading, Modal, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import { useState } from 'react'
import Plot from 'react-plotly.js'
import { FullScreen } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { getMinMaxFromGraphData } from '../../../util/helperFunctions';

const ChartCard = ({ sensor, title, loading, graphdata, units, fixedYRangeVariables }) => {

    const [open, setOpen] = useState(false);
    const handleChartModalClose = () => {
        setOpen(false);
    }

    const { min: minValue, max: maxValue } = getMinMaxFromGraphData(graphdata);

    return (
        <div className='model-chart-card'>
            <div className='model-chart-container'>
                {loading && <div className='loading-container model-chart-loading' role='progressbar'>
                    <Loading />
                </div>}
                <div className='model-chart-actions'>
                    <Tooltip overlay={<span>Full Screen</span>}
                        placement='bottom'
                        trigger={<Button size='xsmall' variant='transparent' iconOnly icon={<FullScreen />}
                            onClick={() => setOpen(true)} data-testid='full-screen-button' />}
                    />
                </div>
                {!loading && graphdata?.length > 0 && <Plot
                    useResizeHandler={true}
                    data={graphdata}
                    className='model-chart'
                    layout={{
                        autosize: true,
                        height: "100%",
                        margin: {
                            l: 40,
                            r: 40,
                            b: 20,
                            t: 20,
                            pad: 5
                        },
                        xaxis: {
                            automargin: true,
                            type: "date",
                        },
                        yaxis: {
                            fixedrange: false,
                            side: "left",
                            range: [minValue - 1, maxValue + 1],
                        },
                        legend: {
                            orientation: "h",
                        },
                        hoverdistance: 1,
                        hovermode: "x unified",

                    }} />}
            </div>
            <Modal open={open} onClose={handleChartModalClose} size='large' className='model-chart-modal'>
                <div className='model-chart-modal-header'>
                    <h4>{sensor} - {title}</h4>
                </div>
                <div className='model-chart-modal-body'>
                    <Plot
                        useResizeHandler={true}
                        data={graphdata}
                        className='model-chart'
                        layout={{
                            autosize: true,
                            height: "100%",
                            margin: {
                                l: 40,
                                r: 40,
                                b: 20,
                                t: 20,
                                pad: 5
                            },
                            xaxis: {
                                automargin: true,
                                type: "date",
                            },
                            yaxis: {
                                fixedrange: false,
                                side: "left",
                                range: maxValue - minValue < 1 ? [minValue - 0.25, maxValue + 0.25] : [minValue, maxValue],
                            },
                            legend: {
                                orientation: "h",
                            },
                            hoverdistance: 1,
                            hovermode: "x unified",

                        }} />
                </div>

            </Modal>
        </div>
    )
}

export default ChartCard